import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.css'
})
export class PrivacyPolicyComponent implements OnInit {

  constructor() {

  }

  ngOnInit() {

  }

  privacyPolicy = [
    {
      title: '1. Executive Summary',
      content: `Protecting user privacy is a top priority for TD-CDM. The sorts of information we gather when you use our mobile application, TD-CDM App, how TD-CDM uses and protects that information, and your options regarding this information are all described in this Privacy Policy.`,
      textColor: '#8E0E00'
    },
    {
      title: '2. Information TD-CDM Collects',
      content: `
      <ul>
        <li><strong>Personal Information:</strong> When you voluntarily offer it, as when you create an account or get in touch with us for assistance, TD-CDM may gather personal information about you, including your name, email address, and other identifiable details.</li>
        <li><strong>Non-Personal Information:</strong> Among the non-personal data that TD-CDM might gather are usage statistics, device details, and information about how you interact with our app.</li>
      </ul>
      `,
      textColor: '#8E0E00'
    },
    {
      title: '3. Location Services',
      content: `
      Our app collects location data to provide location-based services, even when the app is closed or not in use. We use your location data to:
      <ul>
        <li>Provide accurate location-based services such as maps, navigation, and location tracking.</li>
      </ul>
      <p>We will only collect your location data with your explicit consent. You will be prompted to grant permission for location access when you first use the app’s location-based features in the TD-CDM App Account Screen. You can change your location permissions at any time through your device’s settings.</p>
      <p>We do not share your location data with any third parties.</p>
      `,
      textColor: '#8E0E00'
    },
    {
      title: '4. How TD-CDM Utilizes Your Data',
      content: `
      TD-CDM uses the collected information for various purposes:
      <ul>
        <li>Providing and maintaining our services.</li>
        <li>Processing your order and transactions.</li>
        <li>Communicating with you, providing customer support, and responding to inquiries.</li>
        <li>Improving and personalizing our services.</li>
        <li>Providing accurate location-based services such as maps, navigation, and location tracking.</li>
      </ul>
      `,
      textColor: '#8E0E00'
    },
    {
      title: '5. Data Security',
      content: `TD-CDM implements reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction.`,
      textColor: '#8E0E00'
    },
    {
      title: '6. Changes to this Privacy Policy',
      content: `TD-CDM reserves the right to update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the effective date to reflect the latest revision.`,
      textColor: '#8E0E00'
    },
  ];
}
